import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";

let cached = null;

/** Signed-in user's referral code (module-cached) — null for guests. */
export default function useMyRefCode() {
  const { user } = useAuth();
  const [code, setCode] = useState(cached);

  useEffect(() => {
    if (!user || cached) return;
    api.get("/me/referrals")
      .then(({ data }) => {
        cached = data.ref_code;
        setCode(data.ref_code);
      })
      .catch(() => {});
  }, [user]);

  return user ? code : null;
}
